module.exports = __webpack_public_path__ + "img/item-2.8c7a92c.svg";